var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpsb1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 188,
    viewBox: "0 0 268 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.999996V138.13C0.5 138.683 0.947716 139.13 1.5 139.13H18.507C19.0593 139.13 19.507 138.683 19.507 138.13V77.6479H96.173V138.13C96.173 138.683 96.6207 139.13 97.173 139.13H114.18C114.732 139.13 115.18 138.683 115.18 138.13V18.8942V16.4306H195.463V25.8777V55.4156H214.511V9.44711C214.511 4.22962 210.18 0 204.838 0H104.628H97.173C96.6207 0 96.173 0.447716 96.173 1V61.4823H19.507V1C19.507 0.447715 19.0593 0 18.507 0H1.5C0.947715 0 0.5 0.447712 0.5 0.999996Z",
    fill: "url(#paint0_linear_3491_31044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.463 129.829C195.463 134.966 199.727 139.13 204.987 139.13C210.247 139.13 214.511 134.966 214.511 129.829V75.8334L195.463 77.6479V129.829Z",
    fill: "url(#paint1_linear_3491_31044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.027 176.788L175.051 176.801L175.076 176.814C185.833 182.293 197.923 185 211.279 185C222.762 185 233.225 182.929 242.617 178.728L242.637 178.72L242.656 178.711C251.408 174.646 258.494 168.87 263.84 161.381C265.538 159.003 264.762 155.81 262.427 154.337L252.522 148.087C250.289 146.679 247.455 147.277 245.889 149.211C241.91 154.127 237.112 157.811 231.471 160.3C225.244 163.047 218.443 164.437 211.03 164.437C202.176 164.437 194.284 162.606 187.292 159.003C180.297 155.244 174.813 150.07 170.788 143.455C166.801 136.903 164.754 129.138 164.754 120.049C164.754 110.959 166.801 103.194 170.788 96.6428C174.811 90.0308 180.288 84.94 187.27 81.3368L187.292 81.3257L187.313 81.3142C194.302 77.5635 202.186 75.6606 211.03 75.6606C218.443 75.6606 225.244 77.05 231.471 79.7974C237.096 82.2791 241.889 86.0165 245.871 91.0574L248.071 89.3194L245.871 91.0575C247.427 93.0281 250.288 93.6504 252.541 92.229L262.442 85.9821C264.762 84.5184 265.547 81.3528 263.881 78.9741C258.527 71.33 251.416 65.5352 242.617 61.6002C233.225 57.3996 222.762 55.3286 211.279 55.3286C197.923 55.3286 185.833 58.0356 175.076 63.5149L175.067 63.5194L175.058 63.524C164.484 68.9986 156.11 76.6016 150.006 86.3218C143.865 96.0999 140.836 107.377 140.836 120.049C140.836 132.575 143.869 143.841 149.994 153.757L150 153.766L150.006 153.776C156.105 163.488 164.468 171.161 175.027 176.788Z",
    stroke: "url(#paint2_linear_3491_31044)",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3491_31044",
    x1: 140.593,
    y1: -8.69564,
    x2: 214.373,
    y2: 131.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3491_31044",
    x1: 140.593,
    y1: -8.69564,
    x2: 214.373,
    y2: 131.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3491_31044",
    x1: 221.544,
    y1: 50.5992,
    x2: 300.044,
    y2: 143.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsb1);
export default __webpack_public_path__ + "static/media/npsb1.89c8748c65f5a6fb03fc80b953ed9de2.svg";
export { ForwardRef as ReactComponent };